// Mock data for Double A Studio website - Luxury Editorial Theme

export const founders = [
  {
    id: 1,
    name: "Alex",
    fullName: "Alexandar Posinak",
    role: "Co-Founder & Web Developer",
    bio: "Alex ha studiato informatica e Web Design fin da giovane, trasformando quella che era una passione in una vera professione. Il mondo digitale e tecnologico è da sempre il suo ambiente naturale, dove riesce a esprimere al massimo creatività, logica e visione strategica.\n\nÈ costantemente orientato all'innovazione, con un forte interesse per l'intelligenza artificiale e le nuove tecnologie, che integra nei progetti per creare soluzioni moderne, efficienti e orientate al futuro.",
    signature: "Alexandar Posinak",
    skills: ["Web Development", "AI Integration", "UI/UX Design", "Full-Stack Development"]
  },
  {
    id: 2,
    name: "Arianna",
    fullName: "Arianna Adriani",
    role: "Co-Founder & Brand Strategist",
    bio: "Arianna ha un solido background in economia e marketing, con una profonda conoscenza della psicologia del cliente e delle strategie di posizionamento. Il suo lavoro si concentra sulla costruzione di brand capaci di comunicare valore, generare fiducia e creare una connessione autentica con il pubblico.\n\nIl suo obiettivo è trasformare la presenza online dei clienti in uno strumento concreto di crescita, unendo strategia, identità e visione a lungo termine. Non si tratta solo di estetica, ma di costruire esperienze digitali che funzionano.\n\nLa sua passione per fotografia, grafica e visual design le permette di mantenere un approccio altamente visivo, elegante e attento al dettaglio, rendendo ogni progetto coerente, distintivo e memorabile.",
    signature: "Arianna Adriani",
    skills: ["Brand Strategy", "Marketing", "Visual Design", "Photography"]
  }
];

export const services = [
  {
    id: 1,
    title: "Web Development",
    subtitle: "Siti web su misura",
    description: "Creiamo siti web unici, su misura per il tuo brand. Design moderno, performance ottimali e user experience impeccabile."
  },
  {
    id: 2,
    title: "Redesign & Upgrade",
    subtitle: "Evoluzione digitale",
    description: "Interveniamo su siti esistenti per migliorarli, aggiornarli e renderli più performanti e accattivanti."
  },
  {
    id: 3,
    title: "Integrazioni",
    subtitle: "Connessioni intelligenti",
    description: "Colleghiamo il tuo sito a servizi esterni, CRM, e-commerce, pagamenti e molto altro."
  },
  {
    id: 4,
    title: "Social Media",
    subtitle: "Gestione completa",
    description: "Gestiamo le tue pagine social in modo completo: contenuti, strategia, crescita e engagement."
  },
  {
    id: 5,
    title: "Digital Ads",
    subtitle: "Promozione mirata",
    description: "Ti supportiamo nella promozione online con campagne mirate che portano risultati concreti."
  },
  {
    id: 6,
    title: "SEO & Visibility",
    subtitle: "Posizionamento",
    description: "Aumentiamo la tua visibilità online con strategie SEO e presenza digitale strategica."
  }
];

export const projects = [
  {
    id: 6,
    title: "ScanMarket.ch",
    client: "Double A Studio",
    category: "Web App",
    description: "Piattaforma web che aggrega annunci second-hand da 5 marketplace svizzeri in un unico posto, con sistema Deal Score e aste live.",
    fullDescription: "ScanMarket.ch è un progetto interno di Double A Studio: una piattaforma innovativa che permette di cercare contemporaneamente su Tutti.ch, Anibis.ch, Ricardo.ch, Shpock e eBay.ch. Il sistema analizza oltre 310'000 annunci e calcola un Deal Score per identificare le migliori occasioni. Include il tracking delle aste live da Ricardo.ch, la geolocalizzazione per mostrare la distanza dagli annunci, un sistema di notifiche intelligenti e la possibilità di salvare le ricerche preferite. L'interfaccia è disponibile in quattro lingue (italiano, tedesco, inglese e francese) per coprire tutte le regioni linguistiche della Svizzera. Il design è pulito, veloce e completamente responsive, con dark mode integrato.",
    image: "/images/scanmarket_desktop.png",
    desktopImage: "/images/scanmarket_desktop.png",
    mobileImage: "/images/scanmarket_mobile.jpeg",
    services: ["Web App Development", "UI/UX Design", "API Integration", "SEO multilingua", "Scraping & Aggregazione dati"],
    year: "2026",
    sector: "Tech / Marketplace",
    location: "Svizzera",
    link: "https://www.scanmarket.ch",
    features: [
      "Ricerca simultanea su 5 marketplace svizzeri",
      "Sistema Deal Score per valutare le occasioni",
      "Tracking aste live da Ricardo.ch",
      "Geolocalizzazione annunci con distanza",
      "Sistema notifiche per nuovi deal",
      "Multilingua completo (IT, DE, EN, FR)",
      "Dark mode integrato",
      "310'000+ annunci aggregati in tempo reale",
      "Salvataggio ricerche e annunci preferiti",
      "Design responsive e ultra-veloce"
    ],
    slug: "scanmarket",
    isRealProject: true,
    clientLogo: "/images/scanmarket/scanmarket_logo.png",
    clientLogoMark: "/images/scanmarket/scanmarket_favicon_padded.png",
    brandIdentityTitle: "Il marchio",
    logoVariants: [
      { src: "/images/scanmarket/scanmarket_logo.png", label: "Logo principale" },
      { src: "/images/scanmarket/scanmarket_favicon.png", label: "Logo mark" }
    ],
    closingQuote: "Trova l'affare prima di tutti gli altri."
  },
  {
    id: 7,
    title: "Trattoria Da Daniele",
    client: "Trattoria Pizzeria Da Daniele",
    category: "Website",
    description: "Restyling completo del sito di una storica trattoria italiana di Soletta. Sito multilingua in 4 lingue, menu del giorno gestibile dal cliente e prenotazioni integrate con Lunchgate.",
    fullDescription: "Per la Trattoria Pizzeria Da Daniele, una delle insegne italiane più amate di Soletta dal 2003, abbiamo rimodernizzato completamente il vecchio sito creandone uno nuovo molto più funzionale, elegante ed efficace. Il nuovo sito racconta l'anima del locale — autentica cucina italiana, pizza nel forno, pasta fresca, vini selezionati e una grande terrazza nel Vigierhof — attraverso un design editoriale caldo e cinematografico, costruito sui colori del brand. Struttura completamente multilingua (Italiano, Tedesco, Francese, Inglese) per intercettare turisti e clientela locale, con SEO ottimizzato per ogni lingua. Il cliente può aggiornare in autonomia il \"Menu del giorno\" e le specialità della settimana. Le prenotazioni sono integrate direttamente con Lunchgate, lo standard svizzero della ristorazione, per gestire i tavoli online senza attriti. Il risultato: una vetrina digitale moderna, veloce e perfettamente allineata all'identità del locale.",
    image: "/images/trattoria_daniele_desktop.jpeg",
    desktopImage: "/images/trattoria_daniele_desktop.jpeg",
    mobileImage: "/images/trattoria_daniele_mobile.jpeg",
    services: ["Web Design", "Sviluppo sito", "SEO multilingua", "Menu del giorno autogestito", "Integrazione Lunchgate"],
    year: "2026",
    sector: "Ristorazione",
    location: "Soletta (Solothurn), Svizzera",
    link: "https://trattoria-daniele.ch",
    features: [
      "Restyling completo dal vecchio sito al nuovo",
      "Sito multilingua in 4 lingue (IT, DE, FR, EN)",
      "SEO ottimizzato per ogni lingua",
      "Menu del giorno personalizzabile dal cliente",
      "Prenotazioni online integrate con Lunchgate",
      "Galleria fotografica del locale e della terrazza",
      "Design editoriale caldo e cinematografico",
      "Ottimizzazione mobile perfetta",
      "Integrazione contatti, telefono e mappa Google",
      "Performance e tempi di caricamento ultra-rapidi"
    ],
    slug: "trattoria-daniele",
    isRealProject: true,
    clientLogo: "/images/trattoria-before-after/trattoria_logo_clean.png",
    clientLogoMark: "/images/trattoria-before-after/trattoria_favicon_clean.png",
    logoVariants: [
      { src: "/images/trattoria-before-after/trattoria_logo_clean.png", label: "Logo principale" },
      { src: "/images/trattoria-before-after/trattoria_favicon_clean.png", label: "Logo mark" }
    ],
    closingQuote: "Una trattoria storica di Soletta, ora con la vetrina digitale che merita.",
    beforeAfter: [
      { key: "home", before: "/images/trattoria-before-after/old_home.jpeg", after: "/images/trattoria-before-after/new_home.jpeg" },
      { key: "gallery", before: "/images/trattoria-before-after/old_gallery.jpeg", after: "/images/trattoria-before-after/new_gallery.jpeg" },
      { key: "menu", before: "/images/trattoria-before-after/old_menu.jpeg", after: "/images/trattoria-before-after/new_menu.jpeg" },
      { key: "contact", before: "/images/trattoria-before-after/old_contact.jpeg", after: "/images/trattoria-before-after/new_contact.jpeg" }
    ]
  },
  {
    id: 1,
    title: "Mezzaluna Ristorante",
    client: "Mezzaluna da Rosi & Andrea",
    category: "Website",
    description: "Sito web elegante per ristorante italiano a conduzione familiare, con prenotazione online e design atmosferico.",
    fullDescription: "Per il Ristorante Mezzaluna di Lavertezzo Piano abbiamo creato un sito web che cattura l'atmosfera calda e accogliente del locale. Il ristorante, gestito con passione da Rosi e Andrea, propone cucina italiana autentica: pizza cotta nel forno a legna, specialità di pesce fresco, carne di qualità, selvaggina, Fondue Chinoise e dolci fatti in casa. Il sito presenta un design raffinato con elementi visivi notturni che richiamano il nome 'Mezzaluna', sistema di prenotazione integrato via WhatsApp, menu completo con prezzi, orari di apertura e recensioni dei clienti.",
    image: "/images/mezzaluna_desktop.jpeg",
    desktopImage: "/images/mezzaluna_desktop.jpeg",
    mobileImage: "/images/mezzaluna_mobile.jpeg",
    services: ["Web Design", "Sviluppo sito", "Prenotazione online", "SEO", "Menu digitale"],
    year: "2026",
    sector: "Ristorazione",
    location: "Lavertezzo Piano, Svizzera",
    link: "https://www.ristorante-mezzaluna.ch",
    features: [
      "Design atmosferico con tema notturno",
      "Sistema di prenotazione tavoli via WhatsApp",
      "Menu digitale completo con prezzi",
      "Sezione recensioni Google integrate",
      "Multilingua (IT/DE/EN)",
      "Ottimizzazione mobile perfetta",
      "Gestione autonoma del Menu del giorno",
      "Sezione a tema festività"
    ],
    slug: "mezzaluna-ristorante",
    isRealProject: true,
    closingQuote: "Dove la passione per la cucina si sente in ogni piatto."
  },
  {
    id: 2,
    title: "Pizzeria Da Linda",
    client: "Pizzeria Da Linda",
    category: "Website",
    description: "Sito web moderno e multilingua con menu completo, ottimizzato per dispositivi mobili e posizionamento SEO internazionale.",
    fullDescription: "Per Pizzeria Da Linda abbiamo progettato e sviluppato un sito web moderno e responsive, pensato per valorizzare il brand, migliorare la presenza online e facilitare il contatto con i clienti. Il sito include un menu digitale completo con tutte le categorie e i prezzi aggiornati, permettendo ai clienti di consultare l'offerta comodamente da qualsiasi dispositivo. Grazie alla struttura multilingua (tedesco e inglese), il sito raggiunge anche la clientela internazionale e germanofona della regione, con SEO ottimizzato per ogni lingua. L'obiettivo principale era creare una vetrina digitale chiara, elegante e immediata che trasformasse i visitatori in clienti.",
    image: "/images/pizzeria_desktop_new.jpeg",
    desktopImage: "/images/pizzeria_desktop_new.jpeg",
    mobileImage: "/images/pizzeria_mobile_new.jpeg",
    services: ["Web Design", "Sviluppo sito", "SEO multilingua", "Menu digitale", "Configurazione dominio"],
    year: "2026",
    sector: "Ristorazione",
    location: "Giubiasco, Svizzera",
    link: "https://www.pizzeriadalinda.ch",
    features: [
      "Design su misura con identità del brand",
      "Menu digitale completo con prezzi",
      "Sito multilingua (Italiano, Tedesco, Inglese)",
      "SEO ottimizzato per ogni lingua",
      "Ottimizzazione mobile perfetta",
      "Configurazione dominio e DNS",
      "Tempi di caricamento ultra-rapidi",
      "Integrazione contatti e navigazione intuitiva"
    ],
    slug: "pizzeria-da-linda",
    isRealProject: true,
    clientLogo: "/images/pizzeria-da-linda/pizzeria_logo_main_clean.png",
    clientLogoMark: "/images/pizzeria-da-linda/pizzeria_logo_main_clean.png",
    logoVariants: [
      { src: "/images/pizzeria-da-linda/pizzeria_logo_main_clean.png", label: "Logo principale" },
      { src: "/images/pizzeria-da-linda/pizzeria_logo_alt2_clean.png", label: "Logo orizzontale" }
    ],
    closingQuote: "Un progetto completo: dal design al posizionamento, tutto pensato per far crescere il business online."
  }
];

export const stats = [
  { value: "50+", label: "Progetti Completati" },
  { value: "100%", label: "Clienti Soddisfatti" },
  { value: "24/7", label: "Supporto" },
  { value: "∞", label: "Creatività" }
];

export const philosophy = {
  title: "La Nostra Filosofia",
  subtitle: "Un sito non è solo un sito",
  points: [
    { text: "È un'identità", icon: "Fingerprint" },
    { text: "È un'esperienza", icon: "Sparkles" },
    { text: "È uno strumento di crescita", icon: "Rocket" }
  ],
  mission: "Il nostro obiettivo è aiutare i nostri clienti ad avere clienti."
};

export const contactInfo = {
  email: "info@doubleastudio.ch",
  phone: "+41 XX XXX XX XX",
  instagram: "https://www.instagram.com/doubleastudioch",
  location: "Svizzera"
};

export const navLinks = [
  { id: "home", page: "home" },
  { id: "about", page: "about" },
  { id: "services", section: "services" },
  { id: "why_us", section: "why_us" },
  { id: "portfolio", section: "portfolio" },
  { id: "faq", section: "faq" },
  { id: "contact", section: "contact" }
];

export const marqueeWords = [
  "WEB DESIGN",
  "BRANDING",
  "DIGITAL",
  "CREATIVE",
  "INNOVATION",
  "STRATEGY",
  "DEVELOPMENT",
  "EXPERIENCE"
];
